import { defineMessages } from 'react-intl';

export default defineMessages({
  close: {
    id: 'view.modal.close',
    defaultMessage: 'Close',
  },
});
